var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 10H11.3333C10.6 10 10 10.6 10 11.3333V20.6667C10 21.4 10.6 22 11.3333 22H20.6667C21.4 22 22 21.4 22 20.6667V11.3333C22 10.6 21.4 10 20.6667 10ZM20.6667 20.6667H11.3333V11.3333H20.6667V20.6667ZM12.6667 14.6667H14V19.3333H12.6667V14.6667ZM15.3333 12.6667H16.6667V19.3333H15.3333V12.6667ZM18 16.6667H19.3333V19.3333H18V16.6667Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCare);
export default __webpack_public_path__ + "static/media/healthCare.5659a46ef3fbfe514c69447b13f56068.svg";
export { ForwardRef as ReactComponent };